var React = require('react');

function TeamHeroFlag4 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m17.352246 451.766889 582.528229-336.32283 156.357753 87.843266-661.3174723 382.832164z","fill":"#4eb684","fillRule":"evenodd","opacity":".05","transform":"matrix(.8660254 .5 -.5 .8660254 211.211623 -399.066741)"}));
}

TeamHeroFlag4.defaultProps = {"height":"156","viewBox":"0 0 765 156","width":"765"};

module.exports = TeamHeroFlag4;

TeamHeroFlag4.default = TeamHeroFlag4;
